import GroupFAQService from '@/service/group-faq'
export default {
  getListGroupFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupFAQService.getListGroupFAQ(payload.page, payload.per_page, payload.status).then(res => {
        commit('getListGroupFAQ', res.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  approvalGroupFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupFAQService.approvalGroupFAQ(payload.group_faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  rejectGroupFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupFAQService.rejectGroupFAQ(payload.group_faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyGroupFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupFAQService.destroyGroupFAQ(payload.group_faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createGroupFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupFAQService.createGroupFAQ(payload.group_faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  showGroupFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupFAQService.showGroupFAQ(payload.group_faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateGroupFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupFAQService.updateGroupFAQ(payload.group_faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-faq/actions.js